import { render, staticRenderFns } from "./theoryLayout.vue?vue&type=template&id=3214b854&scoped=true"
import script from "./theoryLayout.vue?vue&type=script&lang=js"
export * from "./theoryLayout.vue?vue&type=script&lang=js"
import style0 from "./theoryLayout.vue?vue&type=style&index=0&id=3214b854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3214b854",
  null
  
)

export default component.exports